if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
		linkTag.crossOrigin = "use-credentials";
	}

	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"wp-runtime": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"primer-react":1,"app_assets_modules_react-code-view_components_blob-edit_BlobEditor_tsx-app_assets_modules_sec-a5ab39":1,"ui_packages_file-renderer-blob_FileRendererBlob_tsx":1,"app_assets_modules_react-code-view_components_blob-edit_WebCommitDialog_tsx-ui_packages_web-c-e5ee6b":1,"ui_packages_code-view-shared_components_files-search_FileResultsList_tsx":1,"ui_packages_api-insights_components_RequestsChart_tsx-ui_packages_chart-card_ChartCard_module-36b52a":1,"ui_packages_billing-app_components_usage_UsageChart_tsx-ui_packages_chart-card_ChartCard_modu-2aac39":1,"ui_packages_commits_components_Commits_CommitActionBar_tsx":1,"ui_packages_copilot-for-business_routes_Policies_tsx":1,"ui_packages_control-group_ControlGroup_tsx-ui_packages_repos-picker_modes_ReposModes_tsx-ui_p-baa51f":1,"ui_packages_hydro-analytics_hydro-analytics_ts-ui_packages_test-id-props_test-id-props_ts-ui_-85ce9b":1,"ui_packages_copilot-for-business_routes_Models_tsx":1,"ui_packages_copilot-for-business_routes_SeatManagement_tsx-ui_packages_copilot-for-business_c-ae51d3":1,"ui_packages_copilot-for-business_routes_StandaloneSeatManagement_tsx-ui_packages_copilot-for--522120":1,"ui_packages_test-id-props_test-id-props_ts-ui_packages_copilot-metrics-insights_components_ch-8aacf2":1,"ui_packages_delegated-bypass_components_ApproversListDialog_tsx":1,"ui_packages_delegated-bypass_components_RequestForm_SecretScanningRequestForm_tsx":1,"ui_packages_code-view-shared_hooks_shortcuts_ts-ui_packages_code-view-shared_utilities_styles-816c2a":1,"ui_packages_issue-create_dialog_CreateIssueDialogEntry_tsx-ui_packages_copy-to-clipboard_Copy-b3155c":1,"ui_packages_mergebox_components_sections_merge-section_command-line-instructions_CommandLineI-e41d4a":1,"ui_packages_repos-branches_components_StatusCheckRollup_tsx":1,"node_modules_focus-visible_dist_focus-visible_js-ui_packages_test-id-props_test-id-props_ts-u-e8e0b5":1,"node_modules_focus-visible_dist_focus-visible_js-ui_packages_test-id-props_test-id-props_ts-u-2762e3":1,"ui_packages_workbench_components_Debug_DebugDialog_tsx":1,"app_components_stafftools_react_TanstackQueryDevtools_StaffBarReactQueryDevToolsPanel_tsx":1,"ui_packages_document-metadata_document-metadata_ts-ui_packages_fuzzy-score_fuzzy-filter_ts-ui-2c01c7":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded